module.exports = __webpack_public_path__ + "Flag-760.7c38309a8cf34134be6f7a2fe9dfd8a4.svg";